import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import axios from '../../../utils/axiosConfig';
import Swal from 'sweetalert2';

const FormModalCreateVehiculo = ({ onSave, initialData }) => {
    const [placa, setPlaca] = useState('');
    const [marca, setMarca] = useState('');
    const [color, setColor] = useState('');
    const [linea, setLinea] = useState('');
    const [modelo, setModelo] = useState('');
    const [operadorGpsId, setOperadorGpsId] = useState(null);
    const [propietarioId, setPropietarioId] = useState(null);
    const [operadoresGps, setOperadoresGps] = useState([]);
    const [propietarios, setPropietarios] = useState([]);

    const operadorGpsOptions = useMemo(() => operadoresGps.map(operador => ({
        value: operador.IdOperadorGPS,
        label: operador.OperadorGPS,
    })), [operadoresGps]);

    const propietarioOptions = useMemo(() => propietarios.map(propietario => ({
        value: propietario.IdPropietario,
        label: propietario.NombrePropietario,
    })), [propietarios]);

    const selectedOperadorGpsOption = useMemo(
        () => operadorGpsOptions.find(option => String(option.value) === String(operadorGpsId)) || null,
        [operadorGpsId, operadorGpsOptions]
    );

    const selectedPropietarioOption = useMemo(
        () => propietarioOptions.find(option => String(option.value) === String(propietarioId)) || null,
        [propietarioId, propietarioOptions]
    );

    const selectStyles = useMemo(() => ({
        control: (base, state) => ({
            ...base,
            minHeight: '38px',
            borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
            '&:hover': { borderColor: '#86b7fe' },
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: base => ({ ...base, zIndex: 9999 }),
    }), []);

    const getOperadoresGps = async () => {
        await axios.get(process.env.REACT_APP_SERVER + '/maestros/getoperadorgps', {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
        }).then(res => {
            if (res.data.success) { console.log('Operadores GPS cargados:', res.data.data); setOperadoresGps(res.data.data); }
            else Swal.fire('Error', 'No se pudo cargar operadores GPS', 'error');
        })
            .catch(() => Swal.fire('Error', 'Falla de red al cargar lista', 'error'));
    }

    const getPropietarios = async () => {
        await axios.get(process.env.REACT_APP_SERVER + '/maestros/getpropietario', {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
        }).then(res => {
            if (res.data.success) { console.log('Propietarios cargados:', res.data.data); setPropietarios(res.data.data); }
            else Swal.fire('Error', 'No se pudo cargar propietarios', 'error');
        })
            .catch(() => Swal.fire('Error', 'Falla de red al cargar lista', 'error'));
    }


    const submit = e => {
        e.preventDefault();
        if (!placa.trim() || !marca.trim() || !color.trim() || !linea.trim() || !modelo.trim() || !operadorGpsId || !propietarioId) {
            // Puedes usar una alerta aquí si tienes una librería como Swal
            alert('Debe completar todos los campos: Placa, Marca, Color, Línea, Modelo, Operador GPS y Propietario');
            return;
        }
        onSave({ placa, marca, color, linea, modelo, operadorGpsId, propietarioId });
    }

    useEffect(() => {
        if (initialData) {
            console.log('Cargando datos iniciales:', initialData)
            setPlaca(initialData.Placa || '')
            setMarca(initialData.Marca || '')
            setColor(initialData.Color || '')
            setLinea(initialData.Linea || '')
            setModelo(initialData.Modelo || '')
            setOperadorGpsId(initialData.OperadorGpsId || null)
            setPropietarioId(initialData.PropietarioId || null)
        }
    }, [initialData]);

    useEffect(() => {
        getOperadoresGps();
        getPropietarios();
    }, []);
    return (
        <>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Placa</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Placa del vehículo"
                        value={placa}
                        onChange={e => setPlaca(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Marca</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Marca del vehículo"
                        value={marca}
                        onChange={e => setMarca(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Modelo</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Modelo del vehículo"
                        value={modelo}
                        onChange={e => setModelo(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Color</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Color del vehículo"
                        value={color}
                        onChange={e => setColor(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Linea</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Linea del vehículo"
                        value={linea}
                        onChange={e => setLinea(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Operador GPS</label>
                    <Select
                        inputId="vehiculo-operador-gps"
                        classNamePrefix="vehiculo-select"
                        options={operadorGpsOptions}
                        value={selectedOperadorGpsOption}
                        onChange={option => setOperadorGpsId(option?.value || null)}
                        placeholder="Seleccione un operador"
                        noOptionsMessage={() => 'Sin coincidencias'}
                        isClearable
                        isSearchable
                        styles={selectStyles}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                        menuPosition="fixed"
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Propietarios</label>
                    <Select
                        inputId="vehiculo-propietario"
                        classNamePrefix="vehiculo-select"
                        options={propietarioOptions}
                        value={selectedPropietarioOption}
                        onChange={option => setPropietarioId(option?.value || null)}
                        placeholder="Seleccione un propietario"
                        noOptionsMessage={() => 'Sin coincidencias'}
                        isClearable
                        isSearchable
                        styles={selectStyles}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                        menuPosition="fixed"
                    />
                </MDBCol>
            </MDBRow>

            <div className="d-flex justify-content-end">
                <button className='btn-primary-modals-maestros' onClick={submit}>
                    Guardar
                </button>
            </div>
        </>
    )
}

export default FormModalCreateVehiculo
